import Vue from 'vue';
import store from 'store';
import { mapState } from 'vuex';

export default (el) =>
  new Vue({
    components: {
      modal: () => import('../modal/modal.vue'),
    },
    el,
    store,
    name: 'Modal Product Gallery Video',
    computed: {
      ...mapState('global', ['currentProductGalleryVideo']),
    },
  });
